import abi from './Transactions.json';

export const contractABI = abi.abi;

export const contractAddress = '0x2436F9e5c0A3C86CC317D77319927452Fef4B650';